import { useEffect } from "react";
import { useAuth } from "@/providers/AuthProvider";

export default function Home() {
  const { currentTenant, safeNavigate } = useAuth();

  useEffect(() => {
    safeNavigate(`/org/${currentTenant?.id}/dashboard`);
  }, [safeNavigate, currentTenant]);

  return (
    <div className="max-w-4xl mx-auto">
      <p>Redirecting to dashboard...</p>
    </div>
  );
}
